module.exports = "img/videos/2.894183.mp4";